import {ClientEventType} from "../services/client-events/models/ClientEventType";

/** @ngInject */
export default function adviserController($scope, $state, $resource, $http, gridUtil, uiGridConstants, navSvc, $localStorage, $timeout, terms, uiGridExporterConstants, $aside, $interval, Idle, userConfig, $window, $uibModal, clientEventService) {

    //$scope.asideState = {
    //    open: false
    //};
    //
    //$scope.openAside = function(position, backdrop) {
    //    $scope.asideState = {
    //        open: true,
    //        position: position
    //    };
    //
    //    function postClose() {
    //        $scope.asideState.open = false;
    //    }
    //
    //    $aside.open({
    //        templateUrl: 'app/adviser/summary/scratchSummary.tpl.html',
    //        placement: position,
    //        size: 'sm',
    //        backdrop: backdrop,
    //        controller: function($scope, $uibModalInstance) {
    //            $scope.ok = function(e) {
    //                $uibModalInstance.close();
    //                e.stopPropagation();
    //            };
    //            $scope.cancel = function(e) {
    //                $uibModalInstance.dismiss();
    //                e.stopPropagation();
    //            };
    //        }
    //    }).result.then(postClose, postClose);
    //}

    var refreshTimeout;

    function socketRefresh(state) {
        // TODO the delay here is so we see the committed values
        // can be removed when we calculate in realtime
        refreshTimeout = $timeout($scope.refresh, 120000);
    }

    const sub = clientEventService.events()
                                  .filter((evt) => evt.type === ClientEventType.BROKER_STATE_CHANGED)
                                  .subscribe(() => socketRefresh());

    $scope.$on("$destroy", function () {
        $state.current.data.startTour = undefined;

        // TODO this timeout can be removed when we have live updates
        if (refreshTimeout) {
            $timeout.cancel(refreshTimeout);
            refreshTimeout = null;
        }
        $window.onresize = null;

        sub.unsubscribe()
    });

    function barColour(percent) {
        percent = Math.min(percent, 1);
        return "hsla(" + Math.round(120 * (1 - percent)) + ", 70%, 45%, 1)";
    }

    var defaultStorage = {};

    defaultStorage.adviserTour = {
        complete: false,
        skipped: false
    };
    defaultStorage.adviserTable = {
        version: 2
    };

    defaultStorage.adviserIncludeEmptyAccounts = false;


    $scope.$storage = $localStorage.$default(defaultStorage);


    $scope.totalNewBusiness = 0;
    $scope.totalNewBusinessWritten = 0;
    $scope.totalNewBusinessPaid = 0;

    $scope.totalCreditNewBusiness = 0;
    $scope.totalDebitNewBusiness = 0;

    $scope.countCreditNewBusiness = 0;
    $scope.countDebitNewBusiness = 0;

    $scope.totalShortage = 0;
    $scope.totalShortShortage = 0;
    $scope.totalLongShortage = 0;
    $scope.countCreditShortage = 0;
    $scope.countDebitShortage = 0;

    $scope.totalNlv = 0;
    $scope.totalShortNlv = 0;

    $scope.totalChangeInMargin = 0;
    $scope.totalSpanMargin = 0;
    $scope.totalSpanMarginChange = 0;
    $scope.totalPremiumMargin = 0;
    $scope.totalPremiumMarginChange = 0;


    $scope.onFinishTour = function (completed) {
        $scope.$storage.adviserTour.complete = true;
        $scope.$storage.adviserTour.skipped = !completed;
    };

    $scope.startJoyRide = false;

    $state.current.data.startTour = function () {
        $scope.startJoyRide = true;
    };

    $scope.ngJoyrideConfig = [

        {
            type: "title",
            heading: "Adviser Screen",
            text:
                "<span>Welcome to the adviser screen. Here you will find a summary of all your accounts.</span>"

        },
        {
            type: "element",
            selector: "#portfoliosAdviser",
            text: "The portfolios are located in this grid, and are sorted by the largest shortage/excess.",
            placement: "top",
            scroll: true

        },
        {
            type: "element",
            selector: "#adviserMenu",
            text: "Like most screens in the application, you can customise your view based on what is of interest. Clicking on the bars will allow you to choose columns that interest you. As the application is responsive, these settings will be saved per device.",
            placement: "left",
            scroll: true,
            attachToBody: true

        },

        {
            type: "element",
            selector: "#defaultColumnsAdviser",
            text: "The Reset Columns button allows you to factory-reset the table to show the default column settings.",
            placement: "left",
            scroll: true,
            attachToBody: true

        },
        {
            type: "element",
            selector: "#exportDataAdviser",
            text: "You can export data to CSV by clicking this button. You can choose to export all data, or just what is visible based on your filters.",
            placement: "left",
            scroll: true,
            attachToBody: true

        },
        {
            type: "element",
            selector: "#noPositionsFilter",
            text: "When the Empty Acc switch is orange, you will be able to see all available accounts applicable to your access. When it is grey, you will " +
                "only see the accounts that have positions in them.",
            placement: "left",
            scroll: true,
            attachToBody: true

        },
        {
            type: "title",
            heading: "Want to see more detail?",
            text:
                "<span>Clicking on an account number or account name will take you to the portfolio screen.</span>"
        }

    ];

    $scope.toggleIncludeEmptyAccounts = function () {
        $scope.$storage.adviserIncludeEmptyAccounts = !$scope.$storage.adviserIncludeEmptyAccounts;
        $scope.refresh();
    };

    function resizeTable(digest) {

        var oldRowCount = $scope.gridOptions.minRowsToShow;

        var padding = 220 + (userConfig.adviser ? 190 : 0);

        $scope.gridOptions.minRowsToShow = Math.max(10, Math.floor(($window.innerHeight - padding) / $scope.gridOptions.rowHeight));


        if (oldRowCount != $scope.gridOptions.minRowsToShow) {
            var newHeight = ($scope.gridOptions.minRowsToShow * $scope.gridOptions.rowHeight) + 78;
            $scope.gridApi.grid.gridHeight = newHeight;
            // TODO this shouldn't be required as the grid should adjust its render container based on the rows to show or height
            angular.element(document.getElementById("adviserSummary")).css("height", newHeight + "px");
            $scope.gridApi.grid.refresh();
        }

    }

    $window.onresize = function () {
        resizeTable();
        $scope.$digest();
    };

    function saveTablePreferences() {
        $timeout(function () {
            $scope.$storage.adviserTable = {
                version: 2,
                data: $scope.gridApi.saveState.save()
            };

        }, 100);
    }

    // TODO hack to get visibiilty changes saving until there is a callback to trigger it
    $scope.$on("$destroy", function () {
        saveTablePreferences();
    });

    $scope.resetColumnFilters = function () {
        $scope.gridApi.grid.resetColumnSorting();
        $scope.gridApi.grid.clearAllFilters();
    };

    $scope.resetColumnPreferences = function () {
        $scope.$storage.adviserTable = {
            version: 2
        };
        $scope.gridApi.grid.resetColumnSorting();
        $scope.gridApi.grid.clearAllFilters();
        $scope.gridOptions.columnDefs = createDefaultColumns();
    };


    function calculateTotals(gridApi) {
        $scope.totalNewBusiness = 0;
        $scope.totalNewBusinessWritten = 0;
        $scope.totalNewBusinessPaid = 0;

        $scope.totalCreditNewBusiness = 0;
        $scope.totalDebitNewBusiness = 0;

        $scope.countCreditNewBusiness = 0;
        $scope.countDebitNewBusiness = 0;

        $scope.totalShortage = 0;
        $scope.totalShortShortage = 0;
        $scope.totalLongShortage = 0;
        $scope.countCreditShortage = 0;
        $scope.countDebitShortage = 0;

        $scope.totalNlv = 0;
        $scope.totalShortNlv = 0;

        $scope.totalChangeInMargin = 0;
        $scope.totalSpanMargin = 0;
        $scope.totalSpanMarginChange = 0;
        $scope.totalPremiumMargin = 0;
        $scope.totalPremiumMarginChange = 0;

        gridApi.core.getVisibleRows()
               .filter(function (row) {
                   return !row.entity.scratch;
               }).forEach(function (row) {
            var entity = row.entity;

            $scope.totalNewBusiness += entity.newBusiness;

            if (entity.newBusiness > 0) {
                $scope.countCreditNewBusiness++;
                $scope.totalNewBusinessWritten += Math.abs(entity.newBusiness);
            } else if (entity.newBusiness < 0) {
                $scope.countDebitNewBusiness++;
                $scope.totalNewBusinessPaid += Math.abs(entity.newBusiness);
            }

            $scope.totalShortage += entity.shortage;

            if (entity.shortage > 0) {
                $scope.countCreditShortage++;
                $scope.totalLongShortage += entity.shortage;
            } else if (entity.shortage < 0) {
                $scope.countDebitShortage++;
                $scope.totalShortShortage += Math.abs(entity.shortage);
            }


            var nlv = entity.nlv;

            $scope.totalNlv += nlv;

            if (nlv < 0) {
                $scope.totalShortNlv += Math.abs(nlv);
            }

            $scope.totalChangeInMargin += entity.currentMargin - entity.eodMargin;

            $scope.totalSpanMarginChange += entity.spanMargin - entity.eodSpanMargin;
            $scope.totalPremiumMarginChange += entity.premiumMargin - entity.eodPremiumMargin;
            $scope.totalSpanMargin += entity.spanMargin;
            $scope.totalPremiumMargin += entity.premiumMargin;
        });


        $scope.newBusinessPaidPct = (Math.abs($scope.totalNewBusinessPaid) / (Math.abs($scope.totalNewBusinessWritten) + Math.abs($scope.totalNewBusinessPaid))) * 100;
        $scope.newBusinessPaidPct = $scope.newBusinessPaidPct || 0;
        $scope.newBusinessWrittenPct = 100 - $scope.newBusinessPaidPct;


        $scope.newBusinessDebitPct = ($scope.countDebitNewBusiness / ($scope.countDebitNewBusiness + $scope.countCreditNewBusiness)) * 100;
        $scope.newBusinessDebitPct = $scope.newBusinessDebitPct || 0;
        $scope.newBusinessCreditPct = 100 - $scope.newBusinessDebitPct;

        $scope.newBusinessDollarBars = Math.floor($scope.newBusinessWrittenPct / 20);
        $scope.newBusinessPeopleBars = Math.floor($scope.newBusinessCreditPct / 20);

        $scope.shortagePct = (Math.abs($scope.totalShortShortage) / (Math.abs($scope.totalLongShortage) + Math.abs($scope.totalShortShortage))) * 100;
        $scope.shortagePct = $scope.shortagePct || 0;
        $scope.excessPct = 100 - $scope.shortagePct;


        $scope.shortCountPct = ($scope.countDebitShortage / ($scope.countDebitShortage + $scope.countCreditShortage)) * 100;
        $scope.shortCountPct = $scope.shortCountPct || 0;
        $scope.longCountPct = 100 - $scope.shortCountPct;

        $scope.shortageDollarBars = Math.floor($scope.excessPct / 20);
        $scope.shortagePeopleBars = Math.floor($scope.longCountPct / 20);
    }

    $scope.openTablePrefs = function () {
        var position = "right";
        var backdrop = true;

        $scope.asideState = {
            open: true,
            position: position
        };

        $aside.open({
            templateUrl: "/tradefloor/app/layout/tablePrefs/openPosPref.html",
            placement: position,
            size: "sm",
            backdrop: backdrop,
            controller: "TablePrefCtrl",
            resolve: {
                gridApi: function () {
                    return $scope.gridApi;
                }
            }

        });
    };

    function shortLongClass(grid, row, col, rowRenderIndex, colRenderIndex) {
        var value = grid.getCellValue(row, col);
        if (value < 0) {
            return "gridNumber short";
        } else {
            return "gridNumber";
        }
    }

    function etoNetBalanceClass(grid, row, col, rowRenderIndex, colRenderIndex) {
        var value = grid.getCellValue(row, col);
        if (value < 0) {
            return "gridNumber long";
        } else if (value > 0) {
            return "gridNumber short";
        } else {
            return "gridNumber";
        }
    }

    function marginChangeClass(grid, row, col, rowRenderIndex, colRenderIndex) {
        var value = grid.getCellValue(row, col);
        if (value < 0) {
            return "gridNumber marginDown";
        } else if (value > 0) {
            return "gridNumber marginUp";
        } else {
            return "gridNumber";
        }
    }

    function createDefaultColumns() {
        var defaultColumns = [
            {
                name: "favourite",
                type: "string",
                enableFiltering: false,
                displayName: "",
                width: 25,
                enableSorting: false,
                enableHiding: false, cellTooltip: false,
                enableColumnMenu: false,
                enableColumnResizing: false,
                cellTemplate: "<div class=\"ngCellText ui-grid-cell-contents colt{{$index}}\" style=\"text-overflow: unset\"><i ng-click=\"grid.appScope.starPortfolio(row.entity)\" class=\"fa fa-fw icon-star fav\" ng-class=\"{on : row.entity.favourite, off : !row.entity.favourite}\"></i></div>"
            },
            {
                name: "accountNumber",
                type: "string",
                displayName: "Account Number",
                width: "*",
                cellTemplate: "<div class=\"ngCellText ui-grid-cell-contents colt{{$index}}\"><a ui-sref=\"portfolio({portfolioId : row.entity.id})\">{{ row.entity['accountNumber'] }}</a></div>",
                headerCellTemplate: "tf/uiGridHeaderCell",
                term: terms.accNum,
                cellTooltip: false,
                filter: {
                    condition: uiGridConstants.filter.CONTAINS
                }
            },
            {
                name: "accountName",
                type: "string",
                displayName: "Account Name",
                width: "**",
                cellTemplate: "<div class=\"ngCellText ui-grid-cell-contents colt{{$index}}\"><a ui-sref=\"portfolio({portfolioId : row.entity.id})\">{{ row.entity['accountName'] }}</a></div>",
                headerCellTemplate: "tf/uiGridHeaderCell",
                term: terms.accName,
                cellTooltip: false,
                filter: {
                    condition: uiGridConstants.filter.CONTAINS
                }
            },
            {
                name: "org", field: "org.key", displayName: "Organisation", width: "*",
                type: "string", cellTooltip: false,
                visible: false,
                headerCellTemplate: "tf/uiGridHeaderCell",
                filter: {
                    condition: uiGridConstants.filter.CONTAINS
                }
            },
            {
                name: "adviser", field: "adviser.key", displayName: "Adviser", width: "*",
                type: "string", cellTooltip: false,
                headerCellTemplate: "tf/uiGridHeaderCell", term: terms.adviser,
                filter: {
                    condition: uiGridConstants.filter.CONTAINS
                }
            },
            {
                name: "adviserName", field: "adviser.name", displayName: "Adviser Name", width: "*",
                visible: false,
                type: "string", cellTooltip: true,
                headerCellTemplate: "tf/uiGridHeaderCell", term: terms.adviserName,
                filter: {
                    condition: uiGridConstants.filter.CONTAINS
                }
            },
            {
                name: "branch", field: "branch.key", displayName: "Branch", width: "*",
                type: "string", cellTooltip: false,
                headerCellTemplate: "tf/uiGridHeaderCell", term: terms.branch,
                filter: {
                    condition: uiGridConstants.filter.CONTAINS
                }
            },
            {
                name: "branchName", field: "branch.name", displayName: "Branch Name", width: "*",
                visible: false, cellTooltip: true,
                type: "string",
                headerCellTemplate: "tf/uiGridHeaderCell", term: terms.branchName,
                filter: {
                    condition: uiGridConstants.filter.CONTAINS
                }
            },
            {
                name: "utilisation",
                type: "number",
                width: "**", cellTooltip: false,
                headerCellTemplate: "tf/uiGridHeaderCell",
                term: terms.utilisation,
                filter: {
                    condition: uiGridConstants.filter.GREATER_THAN
                },
                displayName: "Utilisation",
                cellTemplate: "<div class=\"ngCellText ui-grid-cell-contents colt{{$index}}\"><uib-progress uib-tooltip-html=\"row.entity.utilisationDescription\"><uib-bar value=\"row.entity.utilisationClamped\"><div style=\"width:100%;height:100%\" ng-style=\"{'background-color' : row.entity.utilisationLevel}\"><span ng-hide=\"row.entity.utilisation < 0.10\">{{row.entity.utilisation | percentage:0}}</span></div></uib-bar></uib-progress></div>"
            },
            {
                name: "totalCash",
                type: "number", cellTooltip: true,
                displayName: "Total Cash", width: "**",
                headerCellTemplate: "tf/uiGridHeaderCell",
                headerCellClass: "gridNumber", cellClass: "gridNumber", footerCellClass: "gridNumber",
                cellFilter: "ledger",
                term: terms.totalCash,
                filter: {
                    condition: uiGridConstants.filter.GREATER_THAN
                },
                footerCellFilter: "ledger",
                aggregationType: uiGridConstants.aggregationTypes.sum, aggregationHideLabel: true
            },
            {
                name: "collateralBalance",
                type: "number",
                displayName: "Collateral", width: "*",
                headerCellTemplate: "tf/uiGridHeaderCell", term: terms.collateral,
                visible: false, cellTooltip: true,
                headerCellClass: "gridNumber", cellClass: "gridNumber", footerCellClass: "gridNumber",
                cellFilter: "ledger",
                filter: {
                    condition: uiGridConstants.filter.GREATER_THAN
                },
                footerCellFilter: "ledger",
                aggregationType: uiGridConstants.aggregationTypes.sum, aggregationHideLabel: true
            },
            {
                name: "unlodgedCollateralValue",
                type: "number",
                headerCellClass: "gridNumber", cellClass: "gridNumber", footerCellClass: "gridNumber",
                headerCellTemplate: "tf/uiGridHeaderCell",
                visible: false,
                width: "**", cellTooltip: true,
                filter: {
                    condition: uiGridConstants.filter.LESS_THAN
                },
                displayName: "Unlodged",
                cellFilter: "tfcurrency:0"
            },
            {
                name: "equityValue",
                type: "number",
                headerCellClass: "gridNumber", cellClass: "gridNumber", footerCellClass: "gridNumber",
                headerCellTemplate: "tf/uiGridHeaderCell",
                visible: false,
                width: "**", cellTooltip: true,
                filter: {
                    condition: uiGridConstants.filter.LESS_THAN
                },
                displayName: "Equity Value",
                cellFilter: "tfcurrency:0"
            },
            {
                name: "cmBalance",
                type: "number",
                displayName: "CMT", width: "*",
                visible: false, cellTooltip: true,
                headerCellTemplate: "tf/uiGridHeaderCell", term: terms.CMA,
                headerCellClass: "gridNumber", cellClass: "gridNumber", footerCellClass: "gridNumber",
                cellFilter: "ledger",
                filter: {
                    condition: uiGridConstants.filter.GREATER_THAN
                },
                footerCellFilter: "ledger",
                aggregationType: uiGridConstants.aggregationTypes.sum, aggregationHideLabel: true
            },
            {
                name: "etoLedger",
                type: "number",
                displayName: "ETO Ledger", width: "*",
                visible: false, cellTooltip: true,
                headerCellTemplate: "tf/uiGridHeaderCell",
                headerCellClass: "gridNumber", cellClass: "gridNumber", footerCellClass: "gridNumber",
                cellFilter: "ledger", term: terms.etoLedger,
                filter: {
                    condition: uiGridConstants.filter.GREATER_THAN
                }
            },
            {
                name: "equityLedger",
                type: "number",
                displayName: "Equity Ledger", width: "*",
                visible: false, cellTooltip: true,
                headerCellTemplate: "tf/uiGridHeaderCell",
                headerCellClass: "gridNumber", cellClass: "gridNumber", footerCellClass: "gridNumber",
                cellFilter: "ledger", term: terms.equityLedger,
                filter: {
                    condition: uiGridConstants.filter.GREATER_THAN
                }
            },
            {
                name: "cashBalance",
                type: "number",
                displayName: "Ledger", width: "*",
                visible: false, cellTooltip: true,
                headerCellTemplate: "tf/uiGridHeaderCell",
                headerCellClass: "gridNumber", cellClass: "gridNumber", footerCellClass: "gridNumber",
                cellFilter: "ledger", term: terms.ledger,
                filter: {
                    condition: uiGridConstants.filter.GREATER_THAN
                },
                footerCellFilter: "ledger",
                aggregationType: uiGridConstants.aggregationTypes.sum, aggregationHideLabel: true
            },
            {

                name: "asxMargin",
                type: "number",
                displayName: "ASX Margin", cellTooltip: true,
                headerCellClass: "gridNumber", footerCellClass: "gridNumber", width: "**", visible: false,
                aggregationType: uiGridConstants.aggregationTypes.sum, aggregationHideLabel: true,
                footerCellFilter: "ledger",
                cellFilter: "ledger",
                filter: {
                    condition: uiGridConstants.filter.GREATER_THAN
                }, headerCellTemplate: "tf/uiGridHeaderCell", term: terms.asxMargin,
                cellClass: "gridNumber"
            },
            {
                name: "newBusiness",
                type: "number",
                displayName: "New Business", width: "*", cellTooltip: true,
                headerCellTemplate: "tf/uiGridHeaderCell", term: terms.newBusiness,
                headerCellClass: "gridNumber", cellClass: "gridNumber", footerCellClass: "gridNumber",
                cellFilter: "ledger",
                filter: {
                    condition: uiGridConstants.filter.GREATER_THAN
                },
                footerCellFilter: "ledger",
                aggregationType: uiGridConstants.aggregationTypes.sum, aggregationHideLabel: true

            },
            {
                name: "premiumMargin",
                type: "number",
                displayName: "Premium Margin",
                visible: false, cellTooltip: true,
                headerCellTemplate: "tf/uiGridHeaderCell",
                term: terms.premMargin,
                headerCellClass: "gridNumber",
                footerCellClass: "gridNumber",
                aggregationType: uiGridConstants.aggregationTypes.sum,
                aggregationHideLabel: true,
                footerCellFilter: "ledger",
                filter: {
                    condition: uiGridConstants.filter.GREATER_THAN
                },
                width: "**",
                cellFilter: "ledger:0",
                cellClass: shortLongClass
            },
            {
                name: "spanMargin",
                type: "number",
                displayName: "SPAN Margin",
                visible: false, cellTooltip: true,
                headerCellTemplate: "tf/uiGridHeaderCell",
                term: terms.spanMargin,
                headerCellClass: "gridNumber",
                footerCellClass: "gridNumber",
                aggregationType: uiGridConstants.aggregationTypes.sum,
                aggregationHideLabel: true,
                footerCellFilter: "ledger",
                filter: {
                    condition: uiGridConstants.filter.GREATER_THAN
                },
                width: "**",
                cellClass: "gridNumber",
                cellFilter: "ledger:0"
            },
            {
                name: "estAsxMargin", displayName: "Est Margin",
                type: "number",
                headerCellTemplate: "tf/uiGridHeaderCell", term: terms.estMargin,
                headerCellClass: "gridNumber", cellClass: "gridNumber", footerCellClass: "gridNumber",
                aggregationType: uiGridConstants.aggregationTypes.sum, aggregationHideLabel: true,
                footerCellFilter: "ledger", cellTooltip: true,
                cellFilter: "ledger",
                filter: {
                    condition: uiGridConstants.filter.GREATER_THAN
                }, width: "**"
            },
            {
                name: "additionalMargin", displayName: "Additional Margin",
                type: "number",
                visible: false, cellTooltip: true,
                headerCellTemplate: "tf/uiGridHeaderCell", term: terms.addMargin,
                headerCellClass: "gridNumber", cellClass: "gridNumber", footerCellClass: "gridNumber",
                aggregationType: uiGridConstants.aggregationTypes.sum, aggregationHideLabel: true,
                footerCellFilter: "ledger",
                cellFilter: "ledger",
                filter: {
                    condition: uiGridConstants.filter.GREATER_THAN
                }, width: "**"
            },
            {
                name: "clientMargin",
                type: "number",
                displayName: "Initial Margin (ASX)",
                visible: false,
                headerCellTemplate: "tf/uiGridHeaderCell", term: terms.initialMargin,
                headerCellClass: "gridNumber", cellClass: "gridNumber", footerCellClass: "gridNumber",
                aggregationType: uiGridConstants.aggregationTypes.sum, aggregationHideLabel: true,
                footerCellFilter: "ledger", cellTooltip: true,
                cellFilter: "ledger",
                filter: {
                    condition: uiGridConstants.filter.GREATER_THAN
                }, width: "**"
            },
            {
                name: "currentMargin",
                type: "number",
                displayName: "Total Margin",
                headerCellTemplate: "tf/uiGridHeaderCell", term: terms.totalMargin,
                headerCellClass: "gridNumber", cellClass: "gridNumber", footerCellClass: "gridNumber",
                aggregationType: uiGridConstants.aggregationTypes.sum, aggregationHideLabel: true,
                footerCellFilter: "ledger", cellTooltip: true,
                cellFilter: "ledger",
                filter: {
                    condition: uiGridConstants.filter.GREATER_THAN
                }, width: "**"
            },
            {
                name: "estChange",
                type: "number",
                visible: false,
                displayName: "Change on Hour",
                width: "**", cellTooltip: true,
                headerCellTemplate: "tf/uiGridHeaderCell",
                term: terms.advChangeMarginHour,
                aggregationType: uiGridConstants.aggregationTypes.sum,
                aggregationHideLabel: true,
                footerCellFilter: "ledger",
                filter: {
                    condition: uiGridConstants.filter.GREATER_THAN
                },
                headerCellClass: "gridNumber",
                footerCellClass: "gridNumber",
                cellFilter: "ledger:0",
                cellClass: marginChangeClass
            },
            {
                name: "change",
                type: "number",
                visible: false, cellTooltip: true,
                displayName: "Change on Day",
                width: "**",
                headerCellTemplate: "tf/uiGridHeaderCell",
                term: terms.advChangeMarginDay,
                aggregationType: uiGridConstants.aggregationTypes.sum,
                aggregationHideLabel: true,
                footerCellFilter: "ledger",
                filter: {
                    condition: uiGridConstants.filter.GREATER_THAN
                },
                headerCellClass: "gridNumber",
                footerCellClass: "gridNumber",
                cellFilter: "ledger:0",
                cellClass: marginChangeClass
            },
            {
                name: "cashMarginMovement",
                type: "number",
                visible: false, cellTooltip: true,
                term: terms.cashMarginMovement,
                aggregationType: uiGridConstants.aggregationTypes.sum,
                aggregationHideLabel: true,
                footerCellFilter: "ledger",
                headerCellClass: "gridNumber",
                footerCellClass: "gridNumber",
                headerCellTemplate: "tf/uiGridHeaderCell",
                width: "**",
                filter: {
                    condition: uiGridConstants.filter.LESS_THAN
                },
                displayName: "Cash Margin Movement",
                cellFilter: "ledger:0",
                cellClass: marginChangeClass
            },
            {
                name: "asxEtoNetBalance",
                type: "number",
                visible: false, cellTooltip: true,
                aggregationType: uiGridConstants.aggregationTypes.sum,
                aggregationHideLabel: true,
                footerCellFilter: "ledger",
                headerCellClass: "gridNumber",
                footerCellClass: "gridNumber",
                headerCellTemplate: "tf/uiGridHeaderCell",
                width: "**",
                filter: {
                    condition: uiGridConstants.filter.LESS_THAN
                },
                displayName: "Net Balance (ASX)",
                term: terms.asxNetBalance,
                cellFilter: "ledger:0",
                cellClass: etoNetBalanceClass
            },
            {
                name: "etoNetBalance",
                type: "number",
                visible: false, cellTooltip: true,
                aggregationType: uiGridConstants.aggregationTypes.sum,
                aggregationHideLabel: true,
                footerCellFilter: "ledger",
                headerCellClass: "gridNumber",
                footerCellClass: "gridNumber",
                headerCellTemplate: "tf/uiGridHeaderCell",
                width: "**",
                filter: {
                    condition: uiGridConstants.filter.LESS_THAN
                },
                displayName: "Net Balance",
                term: terms.netBalance,
                cellFilter: "ledger:0",
                cellClass: etoNetBalanceClass
            },

            {
                name: "shortage",
                type: "number", cellTooltip: true,
                headerCellClass: "gridNumber",
                headerCellTemplate: "tf/uiGridHeaderCell",
                term: terms.advShortage,
                width: "**",
                filter: {
                    condition: uiGridConstants.filter.LESS_THAN
                },
                displayName: "Shortage/Excess",
                cellFilter: "tfcurrency:0",
                cellClass: shortLongClass
            },
            {
                name: "eodExcess",
                type: "number", cellTooltip: true,
                headerCellClass: "gridNumber",
                headerCellTemplate: "tf/uiGridHeaderCell",
                term: terms.advEodShortage,
                width: "**",
                filter: {
                    condition: uiGridConstants.filter.LESS_THAN
                },
                displayName: "EOD Shortage/Excess",
                cellFilter: "tfcurrency:0",
                visible: false,
                cellClass: shortLongClass
            },
            {
                name: "nlv",
                type: "number",
                headerCellClass: "gridNumber",
                headerCellTemplate: "tf/uiGridHeaderCell",
                term: terms.nlv,
                aggregationType: uiGridConstants.aggregationTypes.sum,
                aggregationHideLabel: true,
                footerCellFilter: "tfcurrency:0",
                footerCellClass: "gridNumber",
                width: "**", cellTooltip: true,
                filter: {
                    condition: uiGridConstants.filter.LESS_THAN
                },
                displayName: "NLV",
                cellFilter: "tfcurrency:0",
                cellClass: shortLongClass
            },
            {
                name: "currentPnl",
                type: "number",
                headerCellClass: "gridNumber",
                headerCellTemplate: "tf/uiGridHeaderCell",
                term: terms.pnl, cellTooltip: true,
                aggregationType: uiGridConstants.aggregationTypes.sum,
                aggregationHideLabel: true,
                footerCellFilter: "ledger",
                footerCellClass: "gridNumber",
                width: "**",
                filter: {
                    condition: uiGridConstants.filter.LESS_THAN
                },
                displayName: "P&L",
                cellFilter: "ledger:0",
                cellClass: shortLongClass
            },
            {
                name: "todayPnl",
                type: "number",
                headerCellClass: "gridNumber",
                headerCellTemplate: "tf/uiGridHeaderCell",
                term: terms.todayPnl, cellTooltip: true,
                aggregationType: uiGridConstants.aggregationTypes.sum,
                aggregationHideLabel: true,
                footerCellFilter: "ledger",
                footerCellClass: "gridNumber",
                width: "**",
                filter: {
                    condition: uiGridConstants.filter.LESS_THAN
                },
                displayName: "Today P&L",
                cellFilter: "ledger:0",
                cellClass: shortLongClass
            }
        ];
        if (userConfig.backOffice === "GAME" || (userConfig.support && (userConfig.branding === "IV" || userConfig.branding === "OPEN_TRADER" || userConfig.branding === "OPEN_MARKETS"))) {
            var ownerEmailCol = {
                name: "ownerEmail", displayName: "Email", width: "**",
                type: "string", cellTooltip: true,
                headerCellTemplate: "tf/uiGridHeaderCell",
                filter: {
                    condition: uiGridConstants.filter.CONTAINS
                }
            };
            defaultColumns.push(ownerEmailCol);

            var ytdPnlCol = {
                name: "ytdPnl", displayName: "YTD P&L", width: "**",
                type: "number", cellTooltip: true,
                cellFilter: "ledger:0",
                cellClass: "gridNumber",
                headerCellTemplate: "tf/uiGridHeaderCell",
                filter: {
                    condition: uiGridConstants.filter.CONTAINS
                }
            };
            defaultColumns.push(ytdPnlCol);

        }

        return defaultColumns;
    }

    $scope.gridOptions = {
        tableName: "Account Summary",
        flatEntityAccess: false,
        enableGridMenu: false,
        exporterMenuCsv: false,
        exporterMenuPdf: false,
        showColumnFooter: true,

        enableRowSelection: false,
        enableRowHeaderSelection: false,
        enableGrouping: false,
        enableColumnResizing: true,
        enableFiltering: true,
        saveFilter: true,
        saveSort: true,
        saveScroll: false,
        saveFocus: false,
        minRowsToShow: Math.max(10, Math.floor(($window.innerHeight - 420) / 30)),
        enableVerticalScrollbar: uiGridConstants.scrollbars.ALWAYS,
        enableHorizontalScrollbar: uiGridConstants.scrollbars.NEVER,
        enablePaging: false,
        excessRows: 15,
        exporterCsvFilename: "accounts.csv",
        exporterSuppressColumns: ["favourite"],
        onRegisterApi: function (gridApi) {
            $scope.gridApi = gridApi;
            gridUtil.disableAnimations(gridApi.grid.element);
            $scope.gridApi.core.on.rowsRendered($scope, calculateTotals);
            $scope.gridApi.colMovable.on.columnPositionChanged($scope, saveTablePreferences);
            $scope.gridApi.core.on.filterChanged($scope, saveTablePreferences);
            $scope.gridApi.core.on.sortChanged($scope, saveTablePreferences);
            $scope.gridApi.core.on.columnVisibilityChanged($scope, saveTablePreferences);
            $scope.gridApi.colResizable.on.columnSizeChanged($scope, saveTablePreferences);
            resizeTable();

            $timeout(function () {
                if ($scope.$storage.adviserTable) {
                    // Reset if the data isn't versioned
                    if ($scope.$storage.adviserTable.version === undefined) {
                        $scope.$storage.adviserTable.version = 2;
                        return;
                    }

                    if ($scope.$storage.adviserTable.data && $scope.$storage.adviserTable.version == 2) {
                        $scope.gridApi.saveState.restore($scope, $scope.$storage.adviserTable.data);
                    }
                }
            }, 0);

        },
        columnDefs: createDefaultColumns(),
        savePreferencesFn: saveTablePreferences,
        columnPresets: [
            {name: "Desktop", icon: "icon-desktop", minWidth: 1200, resetFn: createDefaultColumns}
        ]
    };

    $scope.starPortfolio = function (portfolio) {
        navSvc.toggleStar(portfolio, false);
    };

    $scope.exportCsv = function () {
        $scope.gridApi.exporter.csvExport(uiGridExporterConstants.ALL, uiGridExporterConstants.ALL);
    };

    $scope.exportCsvVisible = function () {
        $scope.gridApi.exporter.csvExport(uiGridExporterConstants.VISIBLE, uiGridExporterConstants.VISIBLE);
    };

    $scope.refresh = function () {
        $http.get("/tradefloor/api/adviser/" + userConfig.backOffice + "/portfolio", {
            params: {
                includeEmpty: $scope.$storage.adviserIncludeEmptyAccounts
            }

        }).then(function (response) {
            var result = response.data;
            $scope.eodPointInTime = result.eodPointInTime;
            $scope.asxPointInTime = result.asxPointInTime;
            $scope.estPointInTime = result.estPointInTime;

            var advisers = result.advisers;
            var branches = result.branches;
            var orgs = result.orgs || [];

            var adviserMap = {};
            var branchMap = {};
            var orgMap = {};

            advisers.forEach(function (a) {
                adviserMap[a.id] = a;
            });

            branches.forEach(function (b) {
                branchMap[b.id] = b;
            });

            orgs.forEach(function (o) {
                orgMap[o.id] = o;
            });

            var summaries = result.summaries;
            var noMargin = function (portfolio) {
                return portfolio.currentMargin > 0;
            };

            var noChange = function (portfolio) {
                return portfolio.currentMargin > 0;
            };

            var byMargin = function (a, b) {
                if (a.currentMargin > b.currentMargin)
                    return -1;
                if (a.currentMargin < b.currentMargin)
                    return 1;

                return 0;
            };

            var byShortage = function (a, b) {
                if (a.shortage < b.shortage)
                    return -1;
                if (a.shortage > b.shortage)
                    return 1;

                return 0;
            };

            $scope.adviserScratchAccounts = [];
            $scope.scratchAccountsLoaded = false;
            var gridData = [];

            angular.forEach(summaries, function (portfolio) {

                portfolio.ytdPnl = portfolio.nlv - (portfolio.nlvMark || 0);


                if (portfolio.adviserId) {
                    portfolio.adviser = adviserMap[portfolio.adviserId];
                }

                if (portfolio.branchId) {
                    portfolio.branch = branchMap[portfolio.branchId];
                }

                if (portfolio.orgId) {
                    portfolio.org = orgMap[portfolio.orgId];
                }

                portfolio.totalCash = portfolio.cashBalance + portfolio.collateralBalance + portfolio.cmBalance;

                portfolio.change = portfolio.currentMargin - portfolio.eodMargin;
                portfolio.estChange = portfolio.currentMargin - portfolio.clientMargin;
                portfolio.additionalMargin = portfolio.currentMargin - portfolio.estAsxMargin;

                if (portfolio.reportedMargin != null) {
                    portfolio.changeOnReported = portfolio.reportedMargin - portfolio.eodMargin;
                } else {
                    portfolio.changeOnReported = 0;
                }

                portfolio.cashAvailable = portfolio.cashBalance - portfolio.cashUsed;
                portfolio.cmAvailable = portfolio.cmBalance - portfolio.cmUsed;
                portfolio.collateralAvailable = portfolio.collateralBalance - portfolio.collateralUsed;

                var numberStyle = {style: "decimal", minimumFractionDigits: 2, maximumFractionDigits: 2};
                portfolio.utilisationLevel = barColour(portfolio.utilisation);

                portfolio.utilisationClamped = Math.min(100, portfolio.utilisation * 100);

                portfolio.utilisationDescription = "Collateral: " + portfolio.collateralUsed.toLocaleString(undefined, numberStyle) + " / " + portfolio.collateralBalance.toLocaleString(undefined, numberStyle) + "<br/>" +
                    "Cash: " + portfolio.cashUsed.toLocaleString(undefined, numberStyle) + " / " + portfolio.cashBalance.toLocaleString(undefined, numberStyle) + "<br/>" +
                    "CM: " + portfolio.cmUsed.toLocaleString(undefined, numberStyle) + " / " + portfolio.cmBalance.toLocaleString(undefined, numberStyle) + "<br/>";

                if (userConfig.adviser && portfolio.scratch && userConfig.backOffice != "GAME") {
                    $scope.adviserScratchAccounts.push(portfolio);
                }
                gridData.push(portfolio)
            });

            // TODO use these filters based on settings from widget
            //$scope.gridOptions.data = result.filter(noMargin);

            $timeout(function () {
                $scope.scratchAccountsLoaded = true;
            }, 0);

            gridData.sort(byShortage);
            $scope.gridOptions.data = gridData;
        });

        $scope.lastUpdated = new Date();
    };

    $scope.refresh();


    //    GLOBAL STRATEGY

    $scope.addBulkBadges = function () {

        var modalInstance = $uibModal.open({
            animation: true,
            templateUrl: "app/adviser/templates/bulkBadges.tpl.html",
            controller: "bulkBadgesCtrl",
            windowClass: "margin-top50 inviteClient",
            size: "lg",
            resolve: {}
        });


    };

    $scope.toggleClientList = function () {
        $scope.gridApi.selection.clearSelectedRows();
        $scope.gridOptions.enableRowSelection = !$scope.gridOptions.enableRowSelection;
        $scope.gridApi.core.notifyDataChange(uiGridConstants.dataChange.OPTIONS);
    };

}
